import { render, staticRenderFns } from "./TaxiDocumentsBox.vue?vue&type=template&id=7570fe19&"
import script from "./TaxiDocumentsBox.vue?vue&type=script&lang=js&"
export * from "./TaxiDocumentsBox.vue?vue&type=script&lang=js&"
import style0 from "./TaxiDocumentsBox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports